<template>
    <div class="container">
        <div class="card-item">
            <div class="card-title">
                <p v-for="(item,index) in tabList" :key="index" @click="tabToggle(index)" :class="{active:index === tabListIndex}">{{item}}</p>
            </div>
            <div class="card-content">
                <creditEvaluation v-if="tabListIndex == 0" />
                <litigationArbitration v-if="tabListIndex == 1" />
                <informationDisclosure v-if="tabListIndex == 2" />
                <otherTenderDocuments v-if="tabListIndex == 3" />
                <otherBankAccountInformation v-if="tabListIndex == 4" />
            </div>
        </div>
    </div>
</template>
<script>
    import creditEvaluation from './main-other-child/credit-evaluation';
    import litigationArbitration from './main-other-child/litigation-arbitration';
    import informationDisclosure from './main-other-child/information-disclosure';
    import otherTenderDocuments from './main-other-child/other-tender-documents';
    import otherBankAccountInformation from './main-other-child/other-bank-account-information'
    export default {
        data(){
            return {
                tabListIndex:0,
                tabList: ['信用评价', '诉讼及仲裁情况', '信息披露', '其他投标证明材料', '其他银行账户信息'],
            }
        },
        components:{
            creditEvaluation,
            litigationArbitration,
            informationDisclosure,
            otherTenderDocuments,
            otherBankAccountInformation,
        },
        methods:{
            tabToggle (index) {
                this.tabListIndex = index;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .container{
        .card-item{
            .card-title{
                cursor: pointer;
                display: flex;
                align-items: center;
                p{
                    font-size: 16px;
                    margin: 0 32px;
                }
                .active{
                    color: #1890FF;
                    border-bottom: 2px solid #1890FF;
                    margin-bottom: 2px;
                }
            }
        }
    }
</style>